import { Component, Input, Output, EventEmitter, ElementRef, Renderer2, ViewChild, forwardRef } from "@angular/core";

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor } from '@angular/forms';
import { SharedGuiSmallModule } from "../../../../../sharedGuiSmall/sharedGuiSmall.module";

const CUSTOM_CHECK_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxComponent),
    multi: true
};

@Component({
    selector: "check",
    templateUrl: "./checkbox.component.html",
    styleUrls: ["./checkbox.component.less"],
    providers: [CUSTOM_CHECK_CONTROL_VALUE_ACCESSOR],
    standalone: true,
    imports: [SharedGuiSmallModule]
})

export class CheckboxComponent implements ControlValueAccessor {

    checkedCls: string = "unchecked";

    private _value: boolean = false;

    @Input()
    dataId: number | undefined;

    @Input()
    dataAny: any | undefined;

    @Input()
    label: string = "";

    @Input()
    labelClass: string = 'b1Color p2font';

    @Input()
    fontSize: string = "";

    @Input()
    testId: string = "nameless";

    @Output() change: EventEmitter<any> = new EventEmitter();

    private inClickHandler: boolean = false;

    disabled: boolean = false;

    @Input()
    checkTop: number = 0;

    @Input() isFullyDisabled: boolean = false;

    constructor(private element: ElementRef, private renderer: Renderer2) {

    }

    ngOnInit(): void {

    }

    ngAfterViewInit(): void {

        this.disabled ? this.disable() : this.enable();

        this.renderer.setStyle(this.element.nativeElement, "font-size", this.fontSize);
        if (this.isFullyDisabled) {
            this.renderer.setStyle(this.element.nativeElement, "opacity", "0.3");
            this.renderer.setStyle(this.element.nativeElement, "pointer-events", "none");
        }

    }

    onClick(): void {

        if (this.isFullyDisabled)
            return;

        this.inClickHandler = true;

        //this.checked = !this.checked;
        this.value = !this._value;

        this.inClickHandler = false;

    }

    disable(): void {

        this.disabled = true;
        this.renderer.setStyle(this.element.nativeElement, "opacity", "0.3");
        this.renderer.setStyle(this.element.nativeElement, "pointer-events", "none");

    }

    enable(): void {


        this.disabled = false;
        this.renderer.setStyle(this.element.nativeElement, "opacity", "1");
        this.renderer.setStyle(this.element.nativeElement, "pointer-events", "");

    }

    public getChecked(): boolean {

        return this._value;

    }


    getCheckedCls(): string {

        return (this._value) ? "checked" : "unchecked";

    }

    get value(): any { return this._value; };

    set value(v: any) {

        if (v !== this._value) {

            this._value = v;
            this.onChange(v);
            this.change.emit(this._value);

        }

    }

    writeValue(value: any) {

        this.value = value;
        this.onChange(value);

    }

    onChange = (_: Function) => { };
    onTouched = () => { };
    registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
    registerOnTouched(fn: () => void): void { this.onTouched = fn; }




}